import React, { useEffect, useRef, useState } from 'react';
import EditorDesign from '../../../../../organisms/editor-design/EditorDesign';
import { useSelector } from 'react-redux';
import { selectActiveLayer } from '../../../../../../redux/toolsSlice';
import ElementInspector from '../personalization/ElementInspector';
import StepRuleBuilder from '../personalization/StepRuleBuilder';
import PathHeaderInspector from '../personalization/PathHeaderInspector';
import '../personalization/Personalization.scss';

const SideToolbar = () => {
  const activeLayer = useSelector((state) => selectActiveLayer(state));
  const [open, setOpen] = useState(true);
  // Theme (colors & fonts) collapses into one panel, closed by default, so
  // authoring leads and styling stops competing with it (per the redesign spec).
  const [themeOpen, setThemeOpen] = useState(false);
  const panelRef = useRef(null);

  const scrollPanelIntoView = () => {
    const panel = panelRef.current;
    const rail = panel?.closest('.un-path-authoring-rail');

    if (!panel || !rail) return;

    rail.scrollTo({
      top: Math.max(panel.offsetTop - 16, 0),
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    if (activeLayer?.id) {
      setOpen(true);
    }
  }, [activeLayer?.id]);

  useEffect(() => {
    if (!open || !activeLayer?.id) return;

    requestAnimationFrame(() => {
      scrollPanelIntoView();
    });
  }, [activeLayer?.id, open]);

  return (
    <div ref={panelRef} className={`un-path-design-panel ${open ? 'is-open' : 'is-closed'}`}>
      {open ? (
        <div className="un-editor-options">
          <div className="un-path-design-panel__header">
            <div>
              <p className="un-path-design-panel__eyebrow">Inspector</p>
              <span className="un-path-design-panel__hint">Edit the selected element, step, or theme.</span>
            </div>
            <button type="button" className="un-path-design-panel__toggle" onClick={() => setOpen(false)}>
              Hide
            </button>
          </div>
          {/* BL-080/081 — contextual inspector. When a text/button element is
              selected we show its Content field; otherwise we show the path-header
              fields and the step display-rule builder. */}
          <div className="un-pers-inspectors">
            {activeLayer?.id ? (
              <ElementInspector />
            ) : (
              <>
                <PathHeaderInspector />
                <StepRuleBuilder />
              </>
            )}
          </div>
          {/* Theme wall collapsed into a single panel so styling no longer competes
              with authoring. Contextual: shows the selected element's styling when a
              layer is active, otherwise the header/content/theme controls. */}
          <div className={`un-theme-wall ${themeOpen ? 'is-open' : 'is-closed'}`}>
            <button type="button" className="un-theme-wall__toggle" onClick={() => setThemeOpen((o) => !o)}>
              <span>Theme — colors &amp; fonts</span>
              <span className="un-theme-wall__chev" aria-hidden="true">{themeOpen ? '▾' : '▸'}</span>
            </button>
            {themeOpen && (
              <div className="un-theme-wall__body">
                <EditorDesign />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="design-editor-close">
          <div className="action-area" onClick={() => setOpen(true)}>
            <p>Design</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SideToolbar;
